import { useMutation, useQueryClient } from '@tanstack/react-query'
import { client } from '../client'
import { queryKeys } from '../keys'

// Set denied actions for an account (bulk)
export function useSetAccountPolicies() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({
      accountName,
      deniedActions,
    }: {
      accountName: string
      deniedActions: Array<string>
    }) => {
      const { data, error } = await client.PUT(
        '/api/v1/policies/{account_name}',
        {
          params: { path: { account_name: accountName } },
          body: { denied_actions: deniedActions },
        },
      )
      if (error) throw error
      return data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.policies.all })
    },
  })
}

// Delete all policies for an account
export function useDeleteAccountPolicies() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (accountName: string) => {
      const { error } = await client.DELETE('/api/v1/policies/{account_name}', {
        params: { path: { account_name: accountName } },
      })
      if (error) throw error
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.policies.all })
    },
  })
}
